import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { API_URL } from '../../lib/utils';
import { Switch } from '../../components/ui/switch';
import { Bell } from 'lucide-react';

const PaceReminderToggle = () => {
  const [optIn, setOptIn] = useState(false);
  const [email, setEmail] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get(`${API_URL}/internship-portal/reminder-settings`);
        setOptIn(!!res.data.pace_reminders_opt_in);
        setEmail(res.data.reminder_email || '');
      } catch (e) { /* ignore */ }
    })();
  }, []);

  const toggle = async (val) => {
    setSaving(true);
    setOptIn(val);
    try {
      await axios.put(`${API_URL}/internship-portal/reminder-settings`, { pace_reminders_opt_in: val, reminder_email: email || null });
      toast.success(val ? 'Weekly reminders turned on.' : 'Weekly reminders turned off.');
    } catch (e) {
      setOptIn(!val);
      toast.error(e.response?.data?.detail || 'Could not update reminders.');
    } finally { setSaving(false); }
  };

  return (
    <div className="bg-white rounded-2xl border p-4 flex items-center justify-between gap-3" data-testid="pace-reminder-toggle">
      <div className="flex items-center gap-3">
        <div className="w-9 h-9 rounded-full bg-secondary/10 flex items-center justify-center flex-shrink-0">
          <Bell className="w-4.5 h-4.5 text-secondary" />
        </div>
        <div>
          <p className="font-semibold text-primary text-sm">Weekly pace reminders</p>
          <p className="text-xs text-gray-500">Get a Monday-morning email with your hours this week and what keeps you on track{email ? ` · ${email}` : ''}.</p>
        </div>
      </div>
      <Switch checked={optIn} disabled={saving} onCheckedChange={toggle} data-testid="pace-reminder-switch" />
    </div>
  );
};

export default PaceReminderToggle;
